export const ENTITY_ROLES = {
  company: [['director', 'Director'], ['secretary', 'Secretary'], ['public_officer', 'Public officer'], ['authorised_signatory', 'Authorised signatory']],
  trust: [['trustee', 'Trustee'], ['corporate_trustee_director', 'Director of corporate trustee'], ['authorised_signatory', 'Authorised signatory']],
  partnership: [['partner', 'Partner']],
  smsf: [['trustee', 'Trustee'], ['corporate_trustee_director', 'Director of corporate trustee']],
};
